import type { FC, PropsWithChildren, ReactElement } from "react";
import React from "react";

import { useLocalStorage } from "../../hooks/local_storage";
import { Footer } from "../components/footer";
import { Header } from "../components/header";

import "./styles.scss";

type Props = {
    enabledMode?: boolean;
    isAuthorized: boolean;
};

export const GeneralLayout: FC<Props> = (props: PropsWithChildren<Props>) => {
    const [mode] = useLocalStorage<"default" | "board">("mode", "default");
    const isBoard = props.enabledMode && mode === "board";
    const element = props.children as ReactElement;

    return (
        <div className="general-layout">
            {!isBoard && <Header isAuthorized={props.isAuthorized} mini />}
            <div className="general-layout__content">
                <div className="general-layout__content-container">
                    <element.type {...element.props} />
                </div>
            </div>
            {!isBoard && <Footer />}
        </div>
    );
};
